// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_o9-0";
export var discountCodeInput = "_o9-1";